module.exports = __webpack_public_path__ + "img/img_tab_pc_on.41bc3bcc.svg";